hrd.HtmlAbstractFactory = hrd.Class.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.HtmlAbstractFactory',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	addDataAttribute: function($element, data, dataValues){
		if(dataValues[data] != undefined){
			var v = dataValues[data];
			if($.isPlainObject(v) || $.isArray(v)){
				$element.attr('data-' + $.dashedCase(data), JSON.stringify(v));
			} else {
				$element.attr('data-' + $.dashedCase(data), v);
			}
		}
	},
	addDataValidationAttributes: function($element, dataValues){
		$.each(dataValues, (p, v) => {
			if(p.indexOf('validation') != -1 && p.length > 10){
				this.addDataAttribute($element, p, dataValues);
			}
		});
	},
	addDataEventAttributes: function($element, dataValues){
		$.each(dataValues, (p, v) => {
			if(p.indexOf('event') != -1 && p.length > 5 + 1){
				this.addDataAttribute($element, p, dataValues);
			}
		});
	},
	addSimpleAttribute: function($element, attr, attrValues){
		if(attrValues[attr] != undefined){
			$element.attr(attr, attrValues[attr]);
		}
	}
});